<template>
    <div class="main">
        <div class="topbox">
            <div :class="smenu == 'jc' ? 'menuitem med' : 'menuitem'" @click="menuclick('jc')">在线监测</div>
            <div :class="smenu == 'znt' ? 'menuitem med' : 'menuitem'" @click="menuclick('znt')">AI智能体</div>
            <div class="menuitem">{{ weatherdata.cityname }}</div>
            <div class="menuitem">{{ weatherdata.weather }} {{ weatherdata.temp }}℃</div>
            <div class="menuitem">
                <span>{{ returnaqilevel(weatherdata.aqi || 0).level }}</span>
            </div>
        </div>
        <div class="homemainbox" :style="{height: smenu == 'jc' ? '' : 'calc(100% - 40px)'}">
            <Data v-if="smenu == 'jc'" />
            <Znt v-else-if="smenu == 'znt' && page==0" @gopage="gopage" />
            <ZntCtr v-else-if="smenu == 'znt' && page==1"  @gopage="gopage" />
        </div>
        <div class="menubox" v-if="smenu == 'jc'">
            <div :class="menu == i ? 'menuitem med' : 'menuitem'" v-for="(item, i) in menulist" :key="i">
                <div class="icon"><img :src="menu == i ? item.iconed : item.icon" /></div>
                <div class="name">{{ item.name }}</div>
            </div>
            <div class="crbox">Copyright ◎ 江西省龙莓乐享智能科技有限公司 版权所有</div>
        </div>
    </div>

</template>

<script>
import router from '../router'
import axios from "axios";
import Data from './Data.vue'
import m1 from '@/assets/img/m1.png'
import m1ed from '@/assets/img/m1ed.png'
import m2 from '@/assets/img/m2.png'
import m2ed from '@/assets/img/m2ed.png'
import Znt from './Znt.vue'
import ZntCtr from './Znt-ctr'
import m3 from '@/assets/img/m3.png'
import m3ed from '@/assets/img/m3ed.png'
import { getweatherdata } from '@/api/bot'
export default {
    name: 'index',
    components: { Data, Znt, ZntCtr },
    data() {
        return {
            menu: 0,
            smenu: 'jc',
            page: 0,
            weatherdata: [],
            menulist: [{
                icon: m1,
                iconed: m1ed,
                name: '数据查看'
            }, {
                icon: m2,
                iconed: m2ed,
                name: 'AI报告'
            }, {
                icon: m3,
                iconed: m3ed,
                name: '个人中心'
            }]
        }
    },
    computed: {
       
    },
    mounted() {
        if (!window.localStorage.getItem('sbtoken')) {
            router.push('/login')
        }
        this.getcitydata()
    },
    methods: {
        gopage(e) {
            console.log('first', e)
            this.page = e
        },
        getcitydata() {
            getweatherdata().then(res => {
                console.log(res)
                this.weatherdata = res.data.real
            })
        },
        menuclick(e) {
            this.smenu = e
        },
        returnaqilevel(aqi) {
            if (aqi <= 0) {
                return {
                    color: '#BEBEBE',
                    level: '-'
                }
            }
            if (aqi < 50) {
                return {
                    color: '#43ce17',
                    level: '优'
                }
            }
            if (aqi < 100) {
                return {
                    color: '#efdc31',
                    level: '良'
                }
            }
            if (aqi < 150) {
                return {
                    color: '#fa0',
                    level: '轻'
                }
            }
            if (aqi < 200) {
                return {
                    color: '#ff401a',
                    level: '中'
                }
            }
            if (aqi < 300) {
                return {
                    color: '#d20040',
                    level: '重'
                }
            }

        }
    }
}




</script>

<style scoped lang="less">
.main {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    .topbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F6F6F6;
        padding: 12px;

        .menuitem {
            font-size: 14px;
            color: #494949;

            span {
                padding: 8px 10px;
                border-radius: 8px;
                background-color: #15d200;
                color: #fff;
                font-size: 12px;
            }
        }

        .med {
            color: #000000d1;
            font-size: 18px;
            position: relative;
        }
        .med::after{
            background: linear-gradient( 352deg, #ffaac000 0%, #D94E6B 100%);
            border-radius: 6px;
            content: '';
            width: 35px;
            height: 10px;
            position: absolute;
            bottom: -4px;
            left: 0;
        }
    }
    .homemainbox {
        width: 100%;
        height: calc(100% - 110px);
    }

    .menubox {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .crbox {
            width: 100%;
            font-size: 8px;
            color: #635f5f70;
            text-align: center;
        }

        .menuitem {
            width: 33.3%;
            height: 100%;
            padding-top: 10px;
            color: #333C4C60;

            .icon {
                width: 100%;
                text-align: center;

                img {
                    width: 20px;
                    margin-bottom: 2px;
                }
            }

            .name {
                margin-top: 0px;
                width: 100%;
                text-align: center;
                font-size: 14px;

            }
        }

        .med {
            color: #3D57A4;
        }
    }
}
</style>
